import React from "react";
import DashboardApp from "./pages/DashboardApp";

export default function App() {
  return <DashboardApp />;
}